<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import MasterLayout from "~/layouts/MasterLayout.vue";
import {usePageStore} from "~/plugins/store/page";
import {createDefaultPage, type Page} from "~/types/Page";
import LoadingDialog from "~/components/utils/LoadingDialog.vue";
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";
import {useRoute} from "vue-router";

export default defineComponent({
  components: {LoadingDialog, MasterLayout},
  setup() {
    useHead({
      title: 'Xiga | Informații',
      meta: [
        {
          name: 'description',
          content: 'META'
        }
      ],
    });
    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const pageStore = usePageStore();
    const route = useRoute();
    const staticPage = ref<Page>(createDefaultPage());
    const showLoadingDialog = ref(false);
    const messageLoadingDialog = ref('');
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({}); // Initialize translations as a reactive reference


    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      showLoadingDialog.value = true;
      messageLoadingDialog.value = translation(translationList.value.loading, 'Se incarcă...');

      if (typeof route.params.slug === 'string' && route.params.slug.length > 0) {
        const pageData = await pageStore.getStaticPage(route.params.slug as string);
        if (pageData && pageData.page_text) {
          staticPage.value = {
            ...pageData,
            page_text: decodeHtml(<string>pageData.page_text)
          };
        }
      }

      showLoadingDialog.value = false;
    });

    const decodeHtml = (html: string) => {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    return {
      translationList,
      translation,
      showLoadingDialog,
      messageLoadingDialog,
      staticPage,
    }
  }
});
</script>

<template>
  <master-layout class="static">
    <v-container class="content-container ">
      <v-container fluid class="component-container-1400mw">
        <v-container class="background-ghost-white" style="max-width: 1200px; border-radius: 15px;">
          <loading-dialog :message="messageLoadingDialog" :show-dialog="showLoadingDialog"/>
          <!-- Content -->
          <v-card class="background-ghost-white" min-height="500" v-if="staticPage && staticPage.page_text" flat rounded="lg">
            <v-card-title>
              <h1 class="text-center">{{ staticPage.title }}</h1>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
              <div v-html="staticPage.page_text"></div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text v-if="staticPage.media && staticPage.media.length">
              <v-row>
                <v-col
                    v-for="(media, index) in staticPage.media"
                    :key="index"
                    cols="12"
                    sm="6"
                    md="4"
                    class="d-flex justify-center"
                >
                  <v-img :src="media.url" :alt="media.alt" class="w-100"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- Undefined page -->
          <v-card v-else-if="(!staticPage || !staticPage.page_text) && !showLoadingDialog"
                  class="d-flex flex-column justify-center align-center" height="500px" color="transparent" flat>
            <div class="fw-500 fs-50">
              Pagină nedefinită
            </div>
          </v-card>
        </v-container>
      </v-container>
    </v-container>
  </master-layout>
</template>


<style scoped>

</style>
